import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {router, navigator} from 'lit-element-router';
import store from '../store';

import getRoutes from '../routes';

@customElement('mode-switch')
export class ModeSwitch extends connect(store)(router(LitElement)) {

	static styles = [
		css`
		  :host {
			margin-right: var(--padding);
			display: flex;
		  } `
	];

	@property({type: Object})
	params = {};

	stateChanged(state) {
		this.status = state.status;
	}

	static get routes() {
		return getRoutes();
	}

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	router(route, params, query, data) {
		this.params = params;
	}

	render() {
		return html`
			<router-link .active=${this.params.mode === 'external'} class="language" .params=${{mode: 'external'}}>external</router-link>
			<router-link .active=${this.params.mode === 'internal'} class="language" .params=${{mode: 'internal'}}>internal</router-link>
		`;
	}
}
